function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { stableStringify } from "@sail/utils";
import { ROOT_QUERY_INCLUDE_VARIABLE_NAME } from "../graphql/compositionFragments/constants";
import shouldGoToNetwork from "./shouldGoToNetwork";
/*
 The logic that decicded whether a subquery should hit a network again (include=true). It has access
 to both Apollo InMemoryCache and our custom query staleness cache. Depending on the state of both
 for the particular query it decides whether it should hit the network.
*/ function calculateIncludeForSubQuery(subQuery, memoryCache, resultStore, forcedFetchFragments, rootQueryInstanceId) {
    var _subQuery_observableFragment;
    if (subQuery.skip) {
        return false;
    }
    const shouldSubQueryBeRefetched = forcedFetchFragments.some(({ hash, variables })=>{
        const isSameHash = hash === subQuery.fragmentHash;
        const areSameVariables = variables !== null ? stableStringify(variables) === stableStringify(subQuery.variables) : true;
        return isSameHash && areSameVariables;
    });
    if (shouldSubQueryBeRefetched) {
        return true;
    }
    // If we are forcing a fetch, we should not use the staleness cache or
    // data in memory cache for the include calculation.
    if (forcedFetchFragments.length > 0) {
        return false;
    }
    if ((_subQuery_observableFragment = subQuery.observableFragment) === null || _subQuery_observableFragment === void 0 ? void 0 : _subQuery_observableFragment.hasConsumerContinuityFor(rootQueryInstanceId)) {
        return false;
    }
    return shouldGoToNetwork(subQuery.subQuery, subQuery.variables, resultStore, memoryCache);
}
export default function calculateSubQueryIncludes(subQueryGroups, forcedFetchFragments, memoryCache, resultStore, deduplicatedIncludeVariables, rootQueryInstanceId) {
    const rootQueryIncludeVariables = {};
    subQueryGroups.forEach((subQueryWithMedata)=>{
        const includeValue = calculateIncludeForSubQuery(subQueryWithMedata, memoryCache, resultStore, forcedFetchFragments, rootQueryInstanceId !== null && rootQueryInstanceId !== void 0 ? rootQueryInstanceId : 'fallback');
        const includeVariableName = `${subQueryWithMedata.prefix}___${ROOT_QUERY_INCLUDE_VARIABLE_NAME}`;
        rootQueryIncludeVariables[includeVariableName] = includeValue;
    });
    // `deduplicatedIncludeVariables` marks the dropped duplicates as include=false,
    // while `includeVariablesForDeduped` covers the unique subqueries we still fetch.
    return _object_spread({}, deduplicatedIncludeVariables, rootQueryIncludeVariables);
}

//# sourceMappingURL=calculateSubQueryIncludes.js.map